import { Box } from '@/ui/primitives';
import type { SxProps, Theme } from '@/ui/primitives';
import type { ReactElement, ReactNode } from 'react';

type TableCellContentProps = { children: ReactNode; sx?: SxProps<Theme> };

export const TableCellContent = ({ children, sx }: TableCellContentProps): ReactElement => {
  const baseSx: SxProps<Theme> = [
    {
      alignItems: 'center',
      boxSizing: 'border-box',
      display: 'flex',
      height: '100%',
      justifyContent: 'flex-start',
      minWidth: 0,
      overflow: 'hidden',
      textAlign: 'left',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: '100%',
    },
  ];
  const resolvedSx: SxProps<Theme> = sx ? [...baseSx, ...(Array.isArray(sx) ? sx : [sx])] : baseSx;
  return <Box sx={resolvedSx}>{children}</Box>;
};
